var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.212 55.3144C7.48913 65.3665 13.8548 93.9403 23.9302 97.41L60.2197 121.405C69.4192 126.346 82.3466 122.161 89.0703 112.067C94.7842 95.4292 108.288 75.4297 121.639 61.5519C128.835 44.5147 100.753 33.1906 96.1985 30.7446L65.6573 14.3422C57.2294 9.81571 47.7819 13.6888 41.7223 22.7851C37.5792 35.0556 29.0746 45.7554 18.212 55.3144Z",
    fill: "#DCCBBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.363 36.5081C103.363 36.5081 27.3815 50.5677 15.9125 61.1833C9.30899 71.097 14.45 91.5047 22.6972 95.9338L56.3118 113.825C64.559 118.254 78.1106 115.452 84.715 105.537C90.6664 89.3761 100.382 73.6807 110.332 65.7761C116.935 55.8624 111.611 40.9373 103.363 36.5081Z",
    fill: "#ECDACD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3212 15.3122C56.9848 10.8351 47.008 16.1375 41.0617 25.0645C37.0184 37.117 28.5823 46.3562 17.8973 55.7214C11.951 64.6484 13.8914 75.5299 22.2277 80.007L52.4345 96.2295C60.7709 100.707 72.3657 97.0941 78.312 88.1671C83.2781 73.4076 90.52 62.7316 99.8583 55.8203C105.805 46.8933 103.864 36.0118 95.528 31.5348L65.3212 15.3122Z",
    fill: "#FFEFE4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1522 54.3385L50.3757 46.646C51.5113 44.9737 52.7301 43.9221 54.0322 43.4913C55.3344 43.0605 56.6811 43.229 58.0339 43.9757C59.4253 44.7437 60.2146 45.8115 60.3772 47.137C60.545 48.4941 59.9947 50.0871 58.7314 51.9475L56.9997 54.4977L62.1402 57.335L58.9891 61.9756L45.1522 54.3385ZM54.1976 52.9511L54.9782 51.8014C55.5744 50.9235 55.865 50.2217 55.8164 49.7063C55.782 49.1701 55.5284 48.8002 55.0839 48.5549C54.6587 48.3202 54.1922 48.2639 53.6701 48.4068C53.148 48.5497 52.6152 49.0603 52.0191 49.9382L51.1248 51.2552L54.1976 52.9511Z",
    fill: "#666262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyP);
export default __webpack_public_path__ + "static/media/key-p.a4c82d5a802fe658d60bfd7d141c3bed.svg";
export { ForwardRef as ReactComponent };